import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
   providedIn: 'root'
})

export class ComplianceHistoryService {
   private newApi = environment.apiUrl;
   private newApi2 = environment.compliance_history;

   private showComplianceHistoryOffcanvasSource = new BehaviorSubject<boolean>(false);
   showComplianceHistoryOffcanvas$ = this.showComplianceHistoryOffcanvasSource.asObservable();

   constructor(
      private http: HttpClient,
   ) {}

   showComplianceHistory() {
      this.showComplianceHistoryOffcanvasSource.next(true);
   }
    
   hideComplianceHistory() {
      this.showComplianceHistoryOffcanvasSource.next(false);
   }

   fetchComplianceHistory<T>(ticker: string): Observable<T> {
      return this.http.get<T>(this.newApi + '/api/compliance-history/' + encodeURIComponent(ticker))
   }

   async fetchComplianceHistoryForIpo<T>(ticker: string): Promise<T> {
      const payload = {
         symbol: ticker,
         start_date: '',
         end_date: '',
         sort_by: '',
         sort_order: ''
      };

      const headers = new HttpHeaders().set('Content-Type', 'application/json');

      const response: any = await lastValueFrom(
         this.http.post<T>(`${this.newApi2}/api/get_compliance_history`, payload, { headers })
      );

      return response;
   }
}
